import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import { isAgentValid } from '../../Util/general';
import './ChatIcon.scss';

const WHATSAPP_PHONE = '41766246701';
const WHATSAPP_BUSINESS_NAME = 'VillaTracker';
const WHATSAPP_PREVIEW_GREETING = 'Hi there 👋\nHow can we help you?';

const CHAT_OPTIONS = [
  { id: 'property',  label: 'Question about a property',     intent: 'Property inquiry' },
  { id: 'booking',   label: 'Booking assistance',            intent: 'Booking assistance' },
  { id: 'pricing',   label: 'Pricing or availability',       intent: 'Pricing / availability' },
  { id: 'technical', label: 'Technical issue with the site', intent: 'Technical issue' },
  { id: 'other',     label: 'Something else',                intent: 'Other' }
];

const formatNow = () =>
  new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const buildWhatsAppLink = (intent) => {
  let agent = {};
  let agency = {};
  try { agent  = JSON.parse(localStorage.getItem('agent') || '{}') || {}; } catch (_) {}
  try { agency = JSON.parse(localStorage.getItem('travelAgency') || '{}') || {}; } catch (_) {}

  const fullName   = [agent.firstName, agent.lastName].filter(Boolean).join(' ').trim();
  const agencyName = agency.agencyName || '';
  const email      = agent.email || '';
  const agentId    = agent.agent_id || '';
  const pageUrl    = typeof window !== 'undefined' ? window.location.href : '';

  const lines = [
    `[${WHATSAPP_BUSINESS_NAME} Inquiry - ${intent}]`,
    fullName    ? `From: ${fullName}${email ? ` (${email})` : ''}` : (email ? `From: ${email}` : ''),
    agencyName  ? `Agency: ${agencyName}`  : '',
    pageUrl     ? `Page: ${pageUrl}`       : '',
    agentId     ? `Agent ID: ${agentId}`   : ''
  ].filter(Boolean);

  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(lines.join('\n'))}`;
};

const ChatIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [now] = useState(formatNow);

  if (!isAgentValid()) return null;

  const handleOptionClick = (option) => {
    window.open(buildWhatsAppLink(option.intent), '_blank', 'noopener,noreferrer');
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="wa-preview" role="dialog" aria-label="WhatsApp chat preview">
          <div className="wa-preview-header">
            <div className="wa-preview-business">
              <h4>{WHATSAPP_BUSINESS_NAME}</h4>
              <span>Online</span>
            </div>
            <button
              type="button"
              className="wa-preview-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </div>

          <div className="wa-preview-body">
            <span className="wa-preview-timestamp">{now}</span>
            <div className="wa-preview-bubble">
              {WHATSAPP_PREVIEW_GREETING.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
              <p className="wa-preview-bubble-hint">Pick a topic to start the chat:</p>
            </div>

            <div className="wa-preview-options">
              {CHAT_OPTIONS.map((opt) => (
                <button
                  key={opt.id}
                  type="button"
                  className="wa-preview-option"
                  onClick={() => handleOptionClick(opt)}
                >
                  <FaWhatsapp /> {opt.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      <button
        type="button"
        className="chat-icon"
        onClick={() => setIsOpen(o => !o)}
        aria-label={isOpen ? 'Close WhatsApp chat' : 'Open WhatsApp chat'}
      >
        <FaWhatsapp className="chat-icon-inner" />
        <span className="chat-icon-dot" aria-hidden="true" />
      </button>
    </>
  );
};

export default ChatIcon;
